import { useState } from "react";

import { DateTimeline } from "@/components/organisms/DateTimeline";
import { FieldEnum } from "@/components/organisms/Field/FieldEnum";
import { EnumColors } from "@/constants/values";
import { useColorScheme } from "@/hooks/useColorScheme";
import { LayoutRouter } from "@/layouts/LayoutRouter";
import { Button } from "@/components/ui/button";

// Generate sample data for testing
const generateSampleData = (count: number) => {
  const data = [];
  const startDate = new Date(2023, 0, 1);

  for (let i = 0; i < count; i++) {
    const date = new Date(startDate);
    date.setDate(startDate.getDate() + i);

    data.push({
      date,
      revenue: Math.random() * 1000 + 500,
      expenses: Math.random() * 800 + 300,
      profit: Math.random() * 500 + 200,
    });
  }

  return data;
};

export default function Page() {
  const { colorScheme, setColorScheme } = useColorScheme();
  const [dataCount, setDataCount] = useState(50);

  const sampleData = generateSampleData(dataCount);

  return (
    <LayoutRouter
      // publicLayout={true}
      className="max-w-250 flex justify-center items-center"
      isVerticalPaddingIncluded={true}
      topbarMaxWidth="lg"
    >
      <div className="flex flex-col gap-8 w-full max-w-200 items-center justify-center">
        <Button
          variant="ghost"
          onClick={() =>
            setColorScheme(colorScheme === "light" ? "dark" : "light")
          }
        >
          Switch color theme
        </Button>

        <div className="flex gap-4 items-center">
          <Button
            variant="ghost"
            onClick={() => setDataCount(Math.max(10, dataCount - 10))}
            disabled={dataCount <= 10}
          >
            -10 Data Points
          </Button>
          <div>Data Points: {dataCount}</div>
          <Button variant="ghost" onClick={() => setDataCount(dataCount + 10)}>
            +10 Data Points
          </Button>
        </div>

        <div className="text-[11px] text-muted-foreground text-center">
          {dataCount > 20
            ? `Scrolling enabled (${dataCount} > 20 maxBars)`
            : `Scrolling disabled (${dataCount} ≤ 20 maxBars)`}
        </div>

        <div className="w-full">
          <DateTimeline
            data={sampleData}
            dateKey="date"
            series={[
              {
                type: "bar",
                valueKeys: ["revenue", "expenses"],
                style: {
                  colors: ["#4CAF50", "#FF5722"],
                  borderRadius: 4,
                },
              },
              {
                type: "line",
                valueKey: "profit",
                style: {
                  color: "#2196F3",
                  strokeWidth: 3,
                },
                curveType: "monotone",
              },
            ]}
            chart={{
              height: 300,
              padding: 0.1,
            }}
            brush={{
              height: 60,
              isVisible: true,
            }}
            tooltip={(datum, series) => {
              if (!datum) return null;
              return (
                <div className="p-2 bg-card rounded-[1px] [box-shadow:2px]">
                  <div>Date: {datum.date.toLocaleDateString()}</div>
                  <div>Revenue: ${datum.revenue.toFixed(2)}</div>
                  <div>Expenses: ${datum.expenses.toFixed(2)}</div>
                  <div>Profit: ${datum.profit.toFixed(2)}</div>
                </div>
              );
            }}
          />
        </div>

        {Object.values(EnumColors).map((colorOptions, index) => (
          <FieldEnum
            key={index}
            value={"enum"}
            valueOptions={{
              enum: [
                {
                  key: "enum",
                  value: "enum",
                },
              ],
              getColors: (mode) => {
                return {
                  enum: colorOptions[mode],
                };
              },
            }}
            isMultiline={false}
          />
        ))}
      </div>
    </LayoutRouter>
  );
}
